import request from "@/utils/request";
import qs from "qs";

/**
 * 重置密码【OK】
 * @param params
 * @returns {*}
 */
export function resetPassword(params) {
  return request.post("/account/changePassword", qs.stringify(params));
}
/**
 * 新增-编辑用户【OK】
 * @param params
 * @returns {*}
 */
export function editAccount(params) {
  return request.post("/account/editAccount", qs.stringify(params));
}

/**
 * 查询账号信息[ok]
 * @param params
 * @returns {*}
 */
export function getBackGroundUserList(params) {
  return request({
    url: "/account/getList",
    method: "get",
    params
  });
}

/**
 * 切换用户状态
 * @param params
 * @returns {*}
 */
export function editStatus(params) {
  return request.post("/account/editStatus", qs.stringify(params));
}

// ============================== vip start ==============================

/**
 * 新建VIP
 * @param params
 * @returns {*}
 */
export function createVipCard(params) {
  return request.post("/api/backend/account/vip/createVipCard", qs.stringify(params));
}

/**
 * 查询VIP列表
 * @param params
 * @returns {*}
 */
export function getUserVipList(params) {
  return request({
    url: "/api/backend/account/vip/getUserVipList",
    method: "get",
    params
  });
}

/**
 * 切换VIP状态
 * @param params
 * @returns {*}
 */
export function switchUserVipStatus(params) {
  return request.post("/api/backend/account/vip/switchUserVipStatus", qs.stringify(params));
}

// ============================== vip end ==============================

// ============================== 用户 start ==============================

/**
 * 查询用户列表
 * @param params
 * @returns {*}
 */
export function getUserList(params) {
  return request({
    url: "/api/backend/account/user/getUserList",
    method: "get",
    params
  });
}

/**
 * 切换用户状态
 * @param params
 * @returns {*}
 */
export function switchUserStatus(params) {
  return request.post("/api/backend/account/user/switchUserStatus", qs.stringify(params));
}

// ============================== 用户 end ==============================
